var _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_545_8128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42401 21C7.81167 21.8914 8.45124 22.6502 9.26416 23.1831C10.0771 23.716 11.028 23.9999 12 23.9999C12.9721 23.9999 13.9229 23.716 14.7359 23.1831C15.5488 22.6502 16.1884 21.8914 16.576 21H7.42401Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.392 12.5489L20.656 6.82593C20.1001 4.82428 18.8914 3.0657 17.2219 1.82943C15.5523 0.593158 13.5177 -0.0499525 11.4409 0.00220786C9.36414 0.0543683 7.36432 0.79881 5.75896 2.11734C4.1536 3.43586 3.03473 5.25289 2.57999 7.27993L1.23199 12.8169C1.05282 13.5527 1.04312 14.3195 1.2036 15.0596C1.36409 15.7996 1.69057 16.4936 2.15841 17.089C2.62626 17.6845 3.22324 18.1659 3.90431 18.4969C4.58538 18.8279 5.33274 18.9999 6.08999 18.9999H17.607C18.3877 19 19.1576 18.8172 19.855 18.4662C20.5524 18.1152 21.1579 17.6057 21.623 16.9787C22.0881 16.3516 22.4 15.6243 22.5335 14.8551C22.667 14.0859 22.6186 13.2961 22.392 12.5489V12.5489Z",
    fill: "#333333"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 5,
    fill: "#039590"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_545_8128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUnread);
export default __webpack_public_path__ + "static/media/notification_unread.f8c488f1f3f985e29c31c87615a19e71.svg";
export { ForwardRef as ReactComponent };